import * as React from "react";
import { View, Text } from "react-native";
import RootNavigation from "./navigation";
import Home from "./screens/Home";
import RestaurantDetail from "./screens/RestaurantDetail";

export default function App() {
    // return <Home />;
    return <RootNavigation />;
}
